import { render, staticRenderFns } from "./BillingTrizetto.vue?vue&type=template&id=6e4d7890"
import script from "./BillingTrizetto.vue?vue&type=script&lang=js"
export * from "./BillingTrizetto.vue?vue&type=script&lang=js"
import style0 from "./BillingTrizetto.vue?vue&type=style&index=0&id=6e4d7890&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports